import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './styles.scss';
import { useMediaQuery } from '@mui/material';
import l from '../../../../lang';
import Table from '../../../common/table';
import RadioButton from '../../../common/radio-button';
import AddNewBankAccount from '../../bank-accounts/add-bank-account-forms/add-bank-account';
import Loading from '../../../common/loading';
import { getBeneficiaries } from '../../../../store/settlements/actions';
import AccordionLeft from '../../../common/accordion-left';
import { showBankAccount } from '../../../../store/bank-accounts/actions';
import Dialog from '../../../common/dialog';
import BankAccountDetail from '../../bank-accounts/bank-account-detail';
import { Urls } from '../../../../config/urls';
import ButtonMore from '../../../common/button-more';

const SelectBeneficiary = ({
  disabled,
  loading,
  data,
  value = '',
  onSelect,
  errorReference,
  externatError,
  newBankAccountSuccess,
  showNewBankAccount,
  fnBeneficiaries,
  fnShowBankAccount,
}) => {
  const isTabletMobile = useMediaQuery('(max-width:768px)');
  const [bankAccountDetail, setBankAccountDetail] = useState(null);

  useEffect(() => {
    fnBeneficiaries();
  }, [fnBeneficiaries]);

  useEffect(() => {
    if (newBankAccountSuccess) {
      fnBeneficiaries();
      fnShowBankAccount(false);
    }
  }, [fnBeneficiaries, fnShowBankAccount, newBankAccountSuccess]);

  return (
    <div className="select-beneficiary">
      {loading && <Loading fullScreem />}
      <div className="select-beneficiary__label">
        {data?.length === 0 ? (
          <div>{l('selectBeneficiary.withoutData.title')}</div>
        ) : (
          <div>{l('selectBeneficiary.titleWithData')}</div>
        )}
      </div>
      <AccordionLeft
        open={showNewBankAccount}
        insideMode
        title={l('bankAccounts.addBankAccount')}
        onClick={() => fnShowBankAccount(!showNewBankAccount)}
        body={<AddNewBankAccount />}
      />
      {data?.length > 0 && (
        <div className="select-beneficiary__table-container">
          <div className="select-beneficiary__table-label">{l('selectBeneficiary.title')}</div>
          <div className="select-beneficiary__table">
            <Table
              idxHiddenColumnsOnMobile={[1, 2, 3, 4]}
              withBtnMenu
              maxHeight="230px"
              headers={[
                '',
                l('bankAccounts.country'),
                l('bankAccounts.name'),
                l('bankAccounts.documentType'),
                l('bankAccounts.document'),
                l('bankAccounts.bankName'),
                l('bankAccounts.bankAccount'),
              ]}
              body={
                data?.map((row, idx) => {
                  const item = [
                    <RadioButton
                      disabled={disabled}
                      name={`rb-beneficiary-${idx.toString()}`}
                      checked={value === `${row.id}`}
                      value={`${row.id}`}
                      onChange={() => onSelect(`${row.id}`)}
                    />,
                    <img
                      alt={`img-country-${row.country}`}
                      className="bank-accounts__country"
                      src={`${Urls.flags.replace(':code', row.country)}`}
                    />,
                    <span>{`${row.beneficiaryFirstName || ''} ${row.beneficiaryLastName || ''}`.trim()}</span>,
                    <span>{row.beneficiaryDocumentType}</span>,
                    <span>{row.beneficiaryDocument}</span>,
                    <span>{row.bankName}</span>,
                    <span>{row.bankAccount}</span>,
                    <ButtonMore onClick={() => setBankAccountDetail(row)} />,
                  ];
                  return item;
                }) || null
              }
            />
            {bankAccountDetail && (
              <Dialog
                dividers={false}
                unpaddingFooter
                unpaddingContent
                fullScreenMobile
                titleCenter
                title={l('bankAccounts.details')}
                handleClose={() => setBankAccountDetail(null)}
                body={<BankAccountDetail detail={bankAccountDetail} />}
              />
            )}
          </div>
        </div>
      )}
      <div ref={errorReference} className="select-beneficiary__error">
        {externatError || <div />}
      </div>
    </div>
  );
};

SelectBeneficiary.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.array,
  newBankAccountSuccess: PropTypes.bool,
  showNewBankAccount: PropTypes.bool,
  fnBeneficiaries: PropTypes.func,
  fnShowBankAccount: PropTypes.func,

  disabled: PropTypes.bool,
  value: PropTypes.string,
  errorReference: PropTypes.object,
  externatError: PropTypes.string,
  onSelect: PropTypes.func,
};

const mapStateToProps = state => ({
  loading: state.settlements.beneficiaries.loading,
  data: state.settlements.beneficiaries.data,
  showNewBankAccount: state.bankAccounts.newBankAccount.show,
  newBankAccountSuccess: state.bankAccounts.newBankAccount.success,
});

const mapDispatchToProps = dispatch => ({
  fnBeneficiaries: () => dispatch(getBeneficiaries()),
  fnShowBankAccount: show => dispatch(showBankAccount(show)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectBeneficiary);
